var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pageConfig)?_c('div',[_c('XTable',{ref:"table",attrs:{"inConfig":_vm.pageConfig,"defaultConfig":_vm.pageConfig.defaultConfig,"showTitle":_vm.showTitle,"select":_vm.select},on:{"event":_vm.event_func,"select":_vm.select}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }